import { ExploraRequest } from 'app/proxy/explora';
import { HomeContent } from 'domain/home-content';
import { Dispatch } from 'react';
import {SignInData} from "../../domain/authTypes";
import {Blog, BlogContent} from "../../domain/blog-content";
import {ProductionsContent} from "../../domain/productions-content";
import {UsContent} from "../../domain/us-content";
import {latestLaunchesContentful} from "../../domain/latest-launches";

export enum Action {
  IsFetching = 'IS_FETCHING',
  FinishedFetching = 'FINISHED_FETCHING',
  ErrorFetching = 'ERROR_FETCHING',
  ClearError = 'CLEAR_ERROR',
  ClearData = 'CLEAR_DATA',
  SaveHomeContent = 'SAVE_HOME_CONTENT',
  SaveProductionsContent = 'SAVE_PRODUCTIONS_CONTENT',
  SaveUsContent = 'SAVE_US_CONTENT',
  SaveBlogContent = 'SAVE_BLOG_CONTENT',
  SaveBlogDetailContent = 'SAVE_DETAIL_BLOG_CONTENT',
  SaveLatestLaunches = 'SAVE_LATEST_LAUNCHES',
  SaveAllLaunches = 'SAVE_ALL_LAUNCHES',

  SetUser = 'SET_USER',
  SignOut = 'SIGN_OUT',
  SetLoading = 'SET_LOADING',
  SetError = 'SET_ERROR',
  NeedVerification = 'NEED_VERIFICATION',
  SetSuccess = 'SET_SUCCESS'
}

export interface AppAction {
  type: Action;
  payload?: any;
}

const getHomeContent = async (dispatch: Dispatch<AppAction>): Promise<void> => {
  dispatch({ type: Action.IsFetching });

  const homeContent = await ExploraRequest.getHomeContent();
  dispatch({ type: Action.SaveHomeContent, payload: homeContent.homeContent as HomeContent });
  dispatch({ type: Action.SaveLatestLaunches, payload: homeContent.LastReleases as latestLaunchesContentful });

  dispatch({ type: Action.FinishedFetching });
};

const getProductionsContent = async (dispatch: Dispatch<AppAction>): Promise<void> => {
  dispatch({ type: Action.IsFetching });

  const {productionContent, allLaunches} = await ExploraRequest.getProductionsContent();
  dispatch({ type: Action.SaveProductionsContent, payload: productionContent });
  dispatch({ type: Action.SaveAllLaunches, payload: allLaunches });

  dispatch({ type: Action.FinishedFetching });
};

const getUsContent = async (dispatch: Dispatch<AppAction>): Promise<void> => {
  dispatch({ type: Action.IsFetching });

  const usContent = await ExploraRequest.getUsContent();
  dispatch({ type: Action.SaveUsContent, payload: usContent });
  dispatch({ type: Action.FinishedFetching });
};

const getBlogContent = async (dispatch: Dispatch<AppAction>): Promise<any> => {
  dispatch({ type: Action.IsFetching });

  const blogContent = await ExploraRequest.getBlogContent();
  dispatch({ type: Action.SaveBlogContent, payload: blogContent });
  dispatch({ type: Action.FinishedFetching });
};

const subscribeUser = async (dispatch: Dispatch<AppAction>, name: string, email: string, policyAccepted: boolean): Promise<void> => {
  dispatch({ type: Action.IsFetching });

  await ExploraRequest.subscribeUser(name, email, policyAccepted);
  dispatch({ type: Action.FinishedFetching });
};

const contactExplora = async (
  dispatch: Dispatch<AppAction>,
  name: string,
  email: string,
  subject: string,
  body: string,
  policyAccepted: boolean,
): Promise<void> => {
  dispatch({ type: Action.IsFetching });

  await ExploraRequest.contactExplora(name, email, subject, body, policyAccepted);
  dispatch({ type: Action.FinishedFetching });
};

const setLoading  = async (dispatch: Dispatch<AppAction>, value : boolean): Promise<void> => {
  dispatch({ type: Action.SetLoading, payload: value });
};

const setNeedVerification = async (dispatch: Dispatch<AppAction>): Promise<void> => {
  dispatch({ type: Action.NeedVerification });
};

const setSuccess  = async (dispatch: Dispatch<AppAction>, msg : string): Promise<void> => {
  dispatch({ type: Action.SetSuccess, payload: msg });
};

export const ExploraRequestAction = {
  getHomeContent,
  getProductionsContent,
  getUsContent,
  getBlogContent,
  subscribeUser,
  contactExplora,
  setLoading,
  setNeedVerification,
  setSuccess
};
